/* ========================== */
/* ========= import ========= */
/* ========================== */
/* ====== React ====== */
import React, { useState } from "react"
/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";

/* ====== Component Js/Jsx ====== */
import { TableSelect } from "./TableSelect";
import { InputTimeField } from "../InputParts/InputTimeField";
import { File } from "../OtherParts/File";
import { assets } from '03CommonApiParts/Configuration';
import { CFArrayConcatFount, CFArrayFount, CFDateEdit, CFFileUpload, CFStingMasterEdit, CFUTCToDateTimeLabelFormatEdit } from "03CommonApiParts/CommonFunction";
// import { ButtonSearch } from "02CommonUiParts/ButtonParts/ButtonBase";
import { Tooltip } from "02CommonUiParts/OtherParts/Tooltip";
import { LeftTitleTableInputField } from "02CommonUiParts/TableParts/TableInputField";
import { LeftTitleTableInputList } from "02CommonUiParts/TableParts/TableInputList";
import { patternCheckMaster, inputCheckMaster, dateCheckMaster } from "03CommonApiParts/CodeDefinition";
import { TableCnfRadio, TableRadio } from "./TableRadio";
import { TableCheck, TableCnfCheck, TableCnfCheck2 } from "./TableCheck";
import { InputErrorMessage } from "./InputErrorMessage";
import { FileUpload } from "02CommonUiParts/OtherParts/FileUpload";
import { TableArray } from "./TableArray";
import { Table } from "./Table";
import { InputVariableListFieldLeft } from "./InputVariableListField";

/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
/* ------テーブル ------*/
const StdLeft = styled.td`//左セル
    white-space: nowrap;
    text-align:left;
    /* width: ${assets().size.leftTableCellL}; */
    padding: 3px;
    font-weight: bold;
    background-color: #2E94B9;
    color: #fff;
    border-bottom: solid 0.5px #fff;
    border-top: solid 0.5px #2E94B9;
`;
const SdivLeftTable = styled.div`//左セルの内枠
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const StdRight = styled.td`//右セル
	padding: 0px 10px;
    background-color: #F4F8FA;
    border-bottom: solid 0.5px #D9D9D9;
    border-right: solid 0.5px #D9D9D9;
`;
const Stable = styled.table`//テーブル全体
    border-radius:10px;
    border-spacing: 0px;
    border-collapse: collapse;
    th, td{
    margin: 0;
    }
    tr:last-child ${StdLeft}{ 
        border-bottom: solid 0.5px #2E94B9;
    }
    tr:first-child ${StdRight} {
        border-top: solid 0.5px #D9D9D9;
    }
`;
const SdivRightCellGroup = styled.div`//右セルの内枠
    display:flex;
    flex-wrap: wrap;
    /* align-items: center; */
    min-height:35px;
    flex-direction: ${props => props.fullWidth ? 'column' : ''};
    gap: ${props => props.gap};
    /* width: ${props => props.fullWidth ? 'fit-content' : ''}; */
`;
const SdivLabelGroup = styled.div`//入力項目一つの枠
    display:flex;
    flex-wrap: wrap;
    align-items:center;
    margin-right:15px;
    width: ${props => props.fullWidth ? 'fit-content' : ''};
    max-height: ${props => props.maxHeight ? props.maxHeight : ''};
    overflow: ${props => props.maxHeight ? 'auto' : ''};
`;
const Sdiv = styled.div`
    padding: 0 0 0 5px;     
	max-width:	400px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	text-align:right;
`;
const Slabel = styled.label` //ラベル表示
    /* margin:0 0 14px 6px; */
    padding: 0 0 0 5px;     
    min-height:20px;
    display:flex;
    align-items: center;
    word-break: break-word;
`;

const Stextarea = styled.textarea`//テキストエリア
    resize: vertical;
    margin:2px 5px 0px 0px; 
    padding:0 5px;
    min-height: 70px;
    /* padding: 3px 3px; */
    width: calc(100% - 20px);
    color: black;
    border: 1px solid #D9D9D9;
    border-radius:3px;
    font-weight: normal;
    font-family: 'Arial';
    font-style:  normal;
    &:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    }
    &:disabled{
        color:black;
        opacity:1;
        background-color:${props => props.readOnly ? 'transparent' : assets().color.disabled};
    }

`;
const SdivGroup = styled.div`
    padding-bottom:12px;
    display: flex;
    flex-wrap: wrap;

`;

// const SdivMessageInputError = styled.div`	//項目入力エラー
// 	height: 16px;
// 	margin: 0px 0px 0px 4px;
// 	padding: 0px;
// 	color: red;
// 	font-size: 12px;
// `;


const SlabelRequireMark = styled.label`
    display: flex;
    align-items: center;
    color: ${assets().color.orange};
    height: 12px;
`;


/*==================*/
/*=====  Main  =====*/
/*==================*/
export const LeftTitleTable = (props) => {//問合せ(詳細入力),問合せ詳細画面のテーブル
    /* --------------------------- */
    /* --------- Instance -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* --------- valiable -------- */
    /* --------------------------- */
    const { payload, register, errors, dataRow, tableConfig, fileInput, setFileInput, changeFlags,fieldsArray,onChangeApply,payloadData,setValue,clearErrors, trigger, minWidthR} = props;
    /* --------------------------- */
    /* --------- state -------- */
    /* --------------------------- */
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open: false,
    });
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    /*------ ファイルを削除したときの処理 ------*/
    const onClickfileDelete = (index) => {
        const fileTmp = fileInput.slice();
        fileTmp.splice(index, 1);
        setFileInput(fileTmp);
    };

    /*------ ドラッグオーバーした時のスタイルを当てる処理 ------*/
    const overStyle = (value) => {
        document.getElementById(value).style.backgroundColor = 'rgba(0,123,195,0.1)'
        // document.getElementById('button').style.backgroundColor = 'rgba(0,123,195,0.1)';
    }

    /*------ 通常時のスタイルに戻す処理 ------*/
    const leaveStyle = (value) => {
        document.getElementById(value).style.backgroundColor = ''
        // document.getElementById('button').style.backgroundColor = 'white';
    };
    /*------ファイルをドロップした時の処理 ------*/
    const onDropFile = (event, value) => {
        event.preventDefault();
        leaveStyle(value);//dragLeaveのスタイルに変更
        const files = event.dataTransfer.files;//ファイルを取得
        /* ファイルアップロード処理 */
        CFFileUpload(files, fileInput, setFileInput, (result) => {

            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                // 特に処理なし

            } else {//APIリクエスト結果 = 異常
                document.getElementById('fileInput').value = '';//inputの中身を空にする

                /* エラーメッセージを表示 */
                setSnackbarMessage({//スナックバー表示   
                    ...snackbarMessage,
                    open: true,
                    message: result.message,//APIによるエラー
                    type: 2,//APIエラー時:1,それ以外:2 
                    level: 'error',//エラースナックバー
                });
            };
        });

    };

    /*------　ドロップターゲットの上にある時の処理 ------*/
    const onDragFileOver = (event, value) => {
        event.preventDefault();
        overStyle(value);//dragLeaveのスタイルに変更
    };

    /*------ ドロップターゲットを離れた時の処理 ------*/
    const onDragFileLeave = (event, value) => {
        event.preventDefault();
        leaveStyle(value);//dragLeaveのスタイルに変更
    };

    /* ----- edit データの中身をチェックして必要な形式で返す ------ */
    const editDataChecker = (data,master) =>{
        let retult;
        switch(data){
            case '未入力':
                retult = data;
                break;
            case 'true':
                retult = CFStingMasterEdit(master,true);
                break;
            case 'false':
                retult = CFStingMasterEdit(master,false);
                break;
            default :
                retult = CFStingMasterEdit(master,data);
                break;
        };
        return retult;
    };

    /* ----- date データの中身をチェックして必要な形式で返す ------ */
    const dateDataChecker = (data) =>{
        let retult;
        switch(data){
            case '未入力':
                retult = data;
                break;
            default :
                retult = CFDateEdit(data);
                break;
        };
        return retult;
    };

    /* ----- dateTime データの中身をチェックして必要な形式で返す ------ */
    const dateTimeDataChecker = (data) =>{
        let retult;
        switch(data){
            case '未入力':
                retult = data;
                break;
            default :
                retult = CFUTCToDateTimeLabelFormatEdit(data);
                break;
        };
        return retult;
    };
    /*--------------------------*/
    /*------ Start Render ------*/
    /*--------------------------*/
    return (
        <>
            <Stable>
                <tbody>
                    {tableConfig.map((head,headIndex) => (
                        head.list ?
                            <tr key={`head_${head.id}_${headIndex}`}>
                                {/* 左セル */}
                                <StdLeft className='leftTableCellL' style={{ fontSize: assets().size.baseText, minWidth: head.minWidth ? head.minWidth : assets().size.leftTableCellL }} key={`${head.id}Left`} >
                                    {/* 左テーブル枠 */}
                                    <SdivLeftTable className="baseText" style={{ fontSize: assets().size.baseText }}>
                                        <div>
                                            {/* 改行を判断して表示 */}
                                            {head.label?.split('\n').map((str, index) => (
                                                <SdivLabelGroup key={`headLabel_${str}_${index}`}>
                                                    <p style={{ margin: '0' }}>{str}</p>
                                                    {index === 0 && head.required &&
                                                        <SlabelRequireMark>＊</SlabelRequireMark>
                                                    }
                                                    {index === 0 &&
                                                        <Tooltip
                                                            mark={true}
                                                            exp={head.exp}
                                                        />
                                                    }
                                                </SdivLabelGroup>
                                            ))}
                                        </div>
                                        {head.rightButton ? head.rightButton : ''}
                                    </SdivLeftTable>
                                </StdLeft>
                                {/* 右セル */}
                                <StdRight 
                                    id={`${head.id}cell`} 
                                    className='baseText' 
                                    style={{ 
                                        fontSize: assets().size.baseText, 
                                        width: head.width ? head.width : assets().size.leftTableCellR, 
                                        minWidth: minWidthR ? minWidthR : '' 
                                    }} 
                                    key={`${head.id}right`}
                                >
                                    {/* 右セルグループ */}
                                    <SdivRightCellGroup fullWidth={head.fullWidth} gap={head.gap}>
                                        {head.list.map((items) => {
                                            let value = dataRow[items.name];
                                            if(dataRow[items.name2] && dataRow[items.name3] && dataRow[items.name4]){
                                                value = value + ' ' + dataRow[items.name2] + ' ' + dataRow[items.name3] + dataRow[items.name4];
                                            }else if(dataRow[items.name2] && dataRow[items.name3]){
                                                value = value + ' ' + dataRow[items.name2] + ' ' + dataRow[items.name3];
                                            }else if(dataRow[items.name2]){
                                                value = value + ' ' + dataRow[items.name2];
                                            };
                                            return(
                                                items && (items.type === 'label' ? //ラベル表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }} maxHeight={items.maxHeight}>
                                                        <Slabel >
                                                            {items.title && dataRow[items.name] ? items.title : ''}{value}{items.rightLabel && dataRow[items.name] ? items.rightLabel : ''}
                                                        </Slabel>
                                                        <Slabel>
                                                            {changeFlags?.[items.name] && '→'}
                                                        </Slabel>
                                                        <Slabel style={{color: 'red'}}>
                                                            {changeFlags?.[items.name] && dataRow[`${items.name}New`]}
                                                        </Slabel>
                                                    </SdivLabelGroup>
                                                :items.type === 'arrowLabel' ? //→表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <Slabel >
                                                        →
                                                        </Slabel>
                                                    </SdivLabelGroup>
                                                :items.type === 'moneyLabel' ? //金額ラベル表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <Slabel >
                                                        {dataRow[items.name]?.toLocaleString()}
                                                        </Slabel>
                                                    </SdivLabelGroup>
                                                : items.type === 'input' ?//入力欄表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <LeftTitleTableInputField
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            title={items.title}
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                            maxLength={items.maxLength}
                                                            width={items.width}
                                                            rightLabel={items.rightLabel}
                                                            placeholder={items.placeholder}
                                                            isDirty={(payloadData?.[items.name]  ?  //payloadDataが存在する時、dataRow[item.name]が存在するとき
                                                            //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                            (dataRow[items.name] ? dataRow[items.name] : false)  !== payloadData?.[items.name] 
                                                            //payloadDataが存在する時、dataRow[item.name]が存在
                                                            : false)}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:value,
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    minLength: { value: items.minLength ? items.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                                                    maxLength: { value: items.maxLength ? items.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                                                                    pattern: {
                                                                        value: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                                                                        message: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                                                                    }
                                                                })}
                                                        />
                                                    </SdivLabelGroup>
                                                : items.type === 'inputList' ?//入力欄表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <LeftTitleTableInputList
                                                            list={items.name}
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            title={items.title}
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                            range={items.master.list} //選択肢
                                                            maxLength={items.maxLength}
                                                            width={items.width}
                                                            rightLabel={items.rightLabel}
                                                            placeholder={items.placeholder}
                                                            isDirty={(payloadData?.[items.name]  ?  //payloadDataが存在する時、dataRow[item.name]が存在するとき
                                                                //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                                (value ? value : false)  !== payloadData?.[items.name] 
                                                                //payloadDataが存在する時、dataRow[item.name]が存在
                                                                : false)}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:value,
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    minLength: { value: items.minLength ? items.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                                                    maxLength: { value: items.maxLength ? items.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                                                                    pattern: {
                                                                        value: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                                                                        message: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                                                                    },
                                                                    onChange: items.onChange ? items.onChange : undefined,
                                                                    validate:{
                                                                        outsideDifined: e => {
                                                                            items.validate && (items.validate(e));
                                                                        },
                                                                        invalidData: v => {
                                                                            if(v){
                                                                                if(!v)return;
                                                                                if(items.noValidation) return;
                                                                                if(!items.master.list) return;
                                                                                /* リストに存在しない値を入力していた場合はエラー表示 */
                                                                                if(!CFArrayConcatFount(items.master.list, v)){
                                                                                    return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
                                                                                }
                                                                            }
                                                                            
                                                                        }
                                                                    }
                                                                })}
                                                        />
                                                    </SdivLabelGroup>
                                                : items.type === 'password' ?//パスワード表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <LeftTitleTableInputField  
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            title={items.title}
                                                            type='password'
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                            maxLength={items.maxLength}
                                                            width={items.width}
                                                            rightLabel={items.rightLabel}
                                                            placeholder={items.placeholder}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name],
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    minLength: { value: items.minLength ? items.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                                                    maxLength: { value: items.maxLength ? items.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                                                                    pattern: {
                                                                        value: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                                                                        message: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                                                                    }
                                                                })}
                                                        />
                                                    </SdivLabelGroup>
                                                :items.type === 'applySelect' ?
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <TableSelect
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name],
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    onChange: (event)=>onChangeApply(event),
                                                                })}
                                                            title={items.title}
                                                            range={dataRow[items.applyList] ? dataRow[items.applyList] : []} //選択肢
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                        />
                                                        {CFArrayFount(dataRow.applyList,'value',dataRow[items.name])?.lastUdr &&
                                                            <Sdiv>{'最終更新者 : ' + CFArrayFount(dataRow.applyList,'value',dataRow[items.name])?.lastUdr}</Sdiv>
                                                        }
                                                        {CFArrayFount(dataRow.applyList,'value',dataRow[items.name])?.lastUpDate &&
                                                            <Slabel>{'最終更新日 : ' + CFArrayFount(dataRow.applyList,'value',dataRow[items.name])?.lastUpDate}</Slabel>
                                                        }

                                                    </SdivLabelGroup>
                                                : items.type === 'select' ?//セレクト表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <TableSelect
                                                            isDirty={(payloadData?.[items.name]  ?  //payloadDataが存在する時、dataRow[item.name]が存在するとき
                                                            //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                            (value ? value : false)  !== payloadData?.[items.name] 
                                                            //payloadDataが存在する時、dataRow[item.name]が存在
                                                            : false)}
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name],
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    onChange: (event)=> items.onChange ? items.onChange(event) : undefined
                                                                })}
                                                            noHidden={!items.required}
                                                            title={items.title}
                                                            range={items.master.list} //選択肢
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                        />
                                                    </SdivLabelGroup>

                                                : items.type === 'datetime' ? //日時表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <InputTimeField
                                                            isDirty={!changeFlags?.[items.name] && 
                                                                //payloadDataが存在する時、dataRow[item.name]が存在すれば
                                                                (payloadData ? 
                                                                    //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                                    (dataRow[items.name] ? dataRow[items.name] : false)  !== payloadData?.[items.name] 
                                                                    //一致する場合はfalse
                                                                    : false)}
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name],
                                                                    required: items.required && CFArrayFount(inputCheckMaster.list, 'value', 'required').label,
                                                                    validate:
                                                                        value => (!items.disabled && value) ? CFArrayFount(
                                                                            dateCheckMaster.list, 'value',
                                                                            ((items.dateValidationList)?.find((item) => item === 'oldDate' ?
                                                                                (new Date(value)).getTime() > (new Date().getTime())
                                                                                : (new Date(value)).getTime() < (new Date(payloadData[item])).getTime()))
                                                                        )?.label : null,
                                                                    pattern: {
                                                                        value: items.pattern ?
                                                                            CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode
                                                                            : null,
                                                                        message: items.pattern ?
                                                                            CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label
                                                                            : null
                                                                    }

                                                                })}
                                                            label={items.title}
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                            type='datetime-local'
                                                        />
                                                    </SdivLabelGroup>
                                                : items.type === 'date' ? //日付表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`}>
                                                        <InputTimeField
                                                            errorMessage={errors[payload]?.[items.name]?.message}
                                                            isDirty={!changeFlags?.[items.name] && 
                                                                //payloadDataが存在する時、dataRow[item.name]が存在すれば
                                                                (payloadData ? 
                                                                    //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                                    dataRow[items.name] !== payloadData?.[items.name] 
                                                                    //一致する場合はfalse
                                                                    : false)}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name],
                                                                    // disabled: items.check && payloadData[items.checkItem]=== items.checkValue ? true : items.disabled, 使ってなさそうなので排除🌟
                                                                    disabled: items.disabled,
                                                                    required: items.requireCheckItem ? payloadData[items.requireCheckItem] === items.requireCheckValue ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label 
                                                                    :items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '':'',
                                                                    onChange: items.onChange ? items.onChange : undefined,
                                                                    // pattern: {
                                                                    //     value: items.pattern ?
                                                                    //         CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode
                                                                    //         : null,
                                                                    //     message: items.pattern ?
                                                                    //         CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label
                                                                    //         : null
                                                                    // },
                                                                    validate:{
                                                                        //startDateよりendDateが大きい場合にエラーを発生させる
                                                                        invalidDate: v => {
                                                                        if(items.startDate){                                                                                        
                                                                                if(v && payloadData?.[items.startDate]){
                                                                                    // v > startDate
                                                                                    if(new Date(v) > new Date(payloadData?.[items.startDate])){
                                                                                        return true;
                                                                                    // v < startDate     
                                                                                    }else{
                                                                                        return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                                                                    }
                                                                                };
                                                                            }else if(items.startDateEql){
                                                                                if(v && payloadData?.[items.startDateEql]){
                                                                                    // v >= startDate
                                                                                    if(new Date(v) >= new Date(payloadData?.[items.startDateEql])){
                                                                                        return true;
                                                                                    // v < startDate     
                                                                                    }else{
                                                                                        return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                                                                    }
                                                                                };
                                                                            }else if(items.endDate){
                                                                                if(v && payloadData?.[items.endDate]){
                                                                                    // endDate > v
                                                                                    if(new Date(payloadData?.[items.endDate]) > new Date(v)){
                                                                                        return true;
                                                                                    // endDate < v   
                                                                                    }else{
                                                                                        return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                                                                    };                                                                                            
                                                                                };
                                                                            };
                                                                        }
                                                                    }
                                                                        
                                                                })}
                                                            label={items.title}
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                            type='date'
                                                        />
                                                    </SdivLabelGroup>
                                                : items.type === 'file' ?// 添付したファイル
                                                    <div key={`rightcell_${items.name}`} style={{ display: 'flex', flexFlow: 'wrap' }}>
                                                        {dataRow[items.name]?.map((file, index) => (
                                                            <div style={{ marginBottom: '12px' }} key={index}>
                                                                <File key={index} data={file}></File>
                                                            </div>
                                                        ))}
                                                    </div>
                                                : items.type === 'fileUpload' ? //ファイル添付
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ flexWrap: 'nowrap', width: '100%' }} onDrop={event => onDropFile(event, `${head.id}cell`)} onDragOver={event => onDragFileOver(event, `${head.id}cell`)} onDragLeave={event => onDragFileLeave(event, `${head.id}cell`)}>
                                                        <FileUpload
                                                            fileInput={fileInput}
                                                            setFileInput={setFileInput} />
                                                        <SdivLabelGroup>
                                                            {fileInput ?
                                                                fileInput.map((file, index) => (
                                                                    // 添付したファイル
                                                                    
                                                                        <File
                                                                            data={file}
                                                                            type='delete' //削除ボタン付きのファイル
                                                                            onClickfileDelete={() => onClickfileDelete(index)}//削除ボタンを押した時の処理
                                                                            key={index}
                                                                        />
                                                                
                                                                ))
                                                                : <></>}
                                                        </SdivLabelGroup>
                                                    </SdivLabelGroup>
                                                : items.type === 'categoryLabel' ? //カテゴリーのラベル表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }}>
                                                        <Slabel >{items.master[dataRow[items.name]].name}</Slabel>：
                                                        <TableSelect
                                                            id={`${items.name2}`}
                                                            register={register(`${payload}.${items.name2}`,//react-hook-form
                                                                {
                                                                    value:dataRow[items.name2],
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                }
                                                            )}
                                                            range={items.master[dataRow[items.name]].list} //選択肢
                                                            disabled={items.disabled}
                                                            readOnly={items.readOnly}
                                                        />
                                                    </SdivLabelGroup>
                                                : items.type === 'radioButton' ? //ラジオボタン
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ color: items.color }} >
                                                        {items.master.list.map((itemsChild, index) =>
                                                            <div key={`${itemsChild.value}${index}`}>
                                                                <TableRadio
                                                                    id={itemsChild.value}
                                                                    label={itemsChild.label}
                                                                    disabled={items.disabled}
                                                                    value={itemsChild.value}
                                                                    isDirty={!changeFlags?.[items.name] && 
                                                                        //payloadDataが存在する時、dataRow[item.name]が存在すれば
                                                                        (payloadData ? 
                                                                            //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                                            (dataRow[items.name] ? dataRow[items.name] : false)  !== payloadData?.[items.name] 
                                                                            //一致する場合はfalse
                                                                            : false)}
                                                                    register={register(`${payload}.${items.name}`,
                                                                        items.func ?
                                                                            {
                                                                                value:dataRow?.[items.name] === null || dataRow?.[items.name] === undefined ?  items.defaultChecked : dataRow[items.name],
                                                                                onChange: (e) => items.func(e.target.value,items.name),
                                                                                required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                            }
                                                                            :
                                                                            {
                                                                                value:dataRow[items.name] === null || dataRow[items.name] === undefined ?  items.defaultChecked: dataRow[items.name],
                                                                                required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                            })}
                                                                />
                                                            </div>
                                                        )}
                                                        {changeFlags?.[items.name]&&<Slabel>→</Slabel>}
                                                        {items.master.list.map((itemsChild, index) =>
                                                            <div key={`${itemsChild.value}${index}New`}>
                                                                {
                                                                    changeFlags?.[items.name] &&
                                                                        <TableCnfRadio
                                                                            label={itemsChild.label}
                                                                            value={itemsChild.value === dataRow[`${items.name}New`]}
                                                                        />
                                                                }
                                                            </div>
                                                        )}
                                                        <InputErrorMessage errorMessage={errors[payload]?.[items.name]?.message}/>
                                                    </SdivLabelGroup>

                                                : items.type === 'table' ? //テーブル
                                                    <div key={`rightcell_${items.name}`} style={{padding:'5px 0',display:'flex'}}>
                                                        <Table
                                                        headCells={items.tableHeader} //ヘッダの設定情報
                                                        bodyCells={items.tableBody} //ボディの設定情報
                                                        dataRow={dataRow[items.name]} //表示データ
                                                        showBottom={true}
                                                        editMode={items.editMode}
                                                        notShowSearchNumber={true}
                                                        changeFlags={changeFlags?.[items.name]}
                                                        />
                                                    </div>
                                                :items.type === 'tableArray' ?
                                                    <TableArray
                                                        key={`rightcell_${items.name}`}
                                                        headCells={items.tableHeader} //ヘッダの設定情報
                                                        bodyCells={items.tableBody} //ボディの設定情報
                                                        dataRow={dataRow[items.name]} //表示データ
                                                        // paperStyle={{maxHeight:'calc(20vh)'}} //高さはここ
                                                        fieldsList={fieldsArray[items.name].fields}
                                                        append={fieldsArray[items.name].append}
                                                        remove={fieldsArray[items.name].remove}
                                                        update={fieldsArray[items.name].update}
                                                        register={register}
                                                        showBottom={true}
                                                        editMode={items.editMode}
                                                        notShowSearchNumber={true}
                                                        payloadCategory={items.name}
                                                        payload={payload}
                                                        errors={errors}
                                                        payloadData={payloadData[items.name]}
                                                        />
                                                :items.type === 'textarea' ? //テキストエリア
                                                    <div key={`rightcell_${items.name}`} style={{ width: items.width ? items.width : '40%'}}
                                                    >
                                                        <Stextarea
                                                            className='baseText' style={{ height: items.height ? items.height : '', fontSize: assets().size.baseText }}
                                                            {...register(`${payload}.${items.name}`,
                                                            {
                                                                value:value,
                                                                required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                minLength: { value: items.minLength ? items.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                                                                maxLength: { value: items.maxLength ? items.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                                                                pattern: {
                                                                    value: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                                                                    message: items.pattern ? CFArrayFount(patternCheckMaster.list, 'value', items.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                                                                }
                                                            })}
                                                            maxLength={items.maxLength}
                                                            disabled={items.disabled}
                                                            autoCorrect='off'
                                                            key={items.name}
                                                            placeholder={items.placeholder}
                                                        />
                                                        {errors[payload]?.[items.name] && <InputErrorMessage errorMessage={errors[payload]?.[items.name]?.message}/>}
                                                    </div>
                                                : items.type === 'checkbox' ? //チェックボックス
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} fullWidth={head.fullWidth}>
                                                        <TableCheck
                                                            // changeFlagがtrueではない時
                                                            isDirty={!changeFlags?.[items.name] && 
                                                                //payloadDataが存在する時、dataRow[item.name]が存在すれば
                                                                (payloadData?.[items.name]? 
                                                                    //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                                    (dataRow[items.name] ? dataRow[items.name] : false)  !== payloadData?.[items.name]
                                                                    //一致する場合はfalse
                                                                    : false)}
                                                            id={items.name}
                                                            label={items.title}
                                                            register={register(`${payload}.${items.name}`,
                                                                {
                                                                    value:dataRow[items.name] === '未入力' ? false : dataRow[items.name] === 'true' ? true:dataRow[items.name] === 'false'?false:dataRow[items.name],
                                                                    required: items.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                                    onChange: (event)=> items.onChange ? items.onChange(event) : undefined
                                                                })}
                                                            disabled={items.disabled}
                                                        />
                                                        <div style={{paddingRight:'5px'}}>{changeFlags?.[items.name]&&<Slabel>→</Slabel>}</div>
                                                        {
                                                            changeFlags?.[items.name] &&
                                                                <>
                                                                <TableCnfCheck
                                                                    label={items.title}
                                                                    defaultChecked={dataRow[`${items.name}New`]}
                                                                />
                                                                {items.title && items.title}
                                                                </>

                                                        }
                                                    </SdivLabelGroup>
                                                : items.type === 'checkboxLabel' ? //チェックボックス
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} fullWidth={head.fullWidth}>
                                                        <TableCnfCheck2
                                                            label={items.title}
                                                            defaultChecked={dataRow[items.name]}
                                                        />
                                                        <div style={{paddingRight:'5px'}}>{changeFlags?.[items.name]&&<Slabel>→</Slabel>}</div>
                                                        {
                                                            changeFlags?.[items.name] &&
                                                                <>
                                                                <TableCnfCheck
                                                                    label={items.title}
                                                                    defaultChecked={dataRow[`${items.name}New`]}
                                                                />
                                                                {items.title && items.title}
                                                                </>

                                                        }
                                                    </SdivLabelGroup>
                                                : items.type === 'button' ?
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} style={{ gap: '0 30px' }}>
                                                        <SdivGroup style={{ padding: 0 }}>{items.button}</SdivGroup>
                                                        <SdivGroup style={{ padding: 0 }}>{items.button1}</SdivGroup>
                                                        <SdivGroup style={{ padding: 0 }}>{items.button2}</SdivGroup>
                                                    </SdivLabelGroup>
                                                : items.type === 'error' ?
                                                    <SdivLabelGroup key={`rightcell_${items.name}`}>
                                                        {
                                                            errors[payload]?.[items.name]?.message &&
                                                                <InputErrorMessage style={items.style} errorMessage={errors[payload]?.[items.name]?.message} />
                                                        }
                                                    </SdivLabelGroup>
                                                : items.type === 'dateLabel' ?//codeからlabelに直して表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`} >
                                                        <Slabel style={{ color: items.color, margin: '0' }}>
                                                            {dateDataChecker(dataRow[items.name])}
                                                        </Slabel>
                                                        <Slabel>
                                                                {changeFlags?.[items.name] && '→'}
                                                        </Slabel>
                                                        <Slabel style={{color: 'red'}}>
                                                            {changeFlags?.[items.name] && (dateDataChecker(dataRow[`${items.name}New`]))}
                                                        </Slabel>
                                                    </SdivLabelGroup>
                                                : items.type === 'dateTimeLabel' ?//codeからlabelに直して表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`}>
                                                        <Slabel style={{ color: items.color, margin: '0' }}>
                                                            {dateTimeDataChecker(dataRow[items.name])}
                                                        </Slabel>
                                                        <Slabel>
                                                                {changeFlags?.[items.name] && '→'}
                                                        </Slabel>
                                                        <Slabel style={{color: 'red'}}>
                                                            {changeFlags?.[items.name] && (dateTimeDataChecker(dataRow[`${items.name}New`]))}
                                                        </Slabel>
                                                    </SdivLabelGroup>
                                                : items.type === 'edit' ?//codeからlabelに直して表示
                                                    <SdivLabelGroup key={`rightcell_${items.name}`}>
                                                        <Slabel style={{ color: items.color, margin: '0' }}>
                                                            {editDataChecker(dataRow[items.name],items.master)}
                                                        </Slabel>
                                                        <Slabel>
                                                                {changeFlags?.[items.name] && '→'}
                                                        </Slabel>
                                                        <Slabel style={{color: 'red'}}>
                                                            {changeFlags?.[items.name] && (editDataChecker(dataRow[`${items.name}New`],items.master))}
                                                        </Slabel>
                                                    </SdivLabelGroup>
												: items.type === 'inputVariableList'?
                                                <div key={`rightcell_${items.name}`}>
                                                    <InputVariableListFieldLeft
                                                        errorMessage={errors[payload]?.[items.name]?.message}
                                                        title={items.title}
                                                        name={`${payload}.${items.name}`}
                                                        readOnly={items.readOnly}
                                                        maxLength={items.maxLength}
                                                        width={items.width}
                                                        rightLabel={items.rightLabel}
                                                        placeholder={items.placeholder}
                                                        range={items.master}
                                                        list={items.name}
                                                        id={`${payload}.${items.name}`}
                                                        onClickButton={items.onClickButton}
                                                        register={register}
                                                        setValue={setValue}
                                                        clearErrors={clearErrors}
                                                        value={dataRow[items.name]}
                                                        trigger={trigger}
                                                        isDirty={(payloadData?.[items.name]  ?  //payloadDataが存在する時、dataRow[item.name]が存在するとき
                                                        //dataRow(dataRow[item.name]をセット/存在しなければfalseをセット)とpayloadDataが一致しない場合はtrue
                                                        (value ? value : false)  !== payloadData?.[items.name] 
                                                        //payloadDataが存在する時、dataRow[item.name]が存在
                                                        : false)}
                                                    />
                                                </div>
                                                : ''
                                                )
                                            )
                                        }
                                            
                                        )}
                                        {/* <SdivMessageInputError>{typeof error === 'undefined' ? '': errorMessageChecker(error[payload]?.[head.id])[0]}</SdivMessageInputError> */}
                                    </SdivRightCellGroup>



                                </StdRight>
                            </tr>
                            : ''
                    ))}
                </tbody>
            </Stable>
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage} />
        </>

    );

}

